export default __webpack_public_path__ + "static/media/work-portfolio-img1.8fd45bdc.png";